module.exports = __webpack_public_path__ + "static/img/zhangjianxing.7c69203.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhangjianxing.jpg
// module id = u8W2
// module chunks = 1